import {GetRefundCities, GetRefundCitiesParams, GetRefundCitiesResponse} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteRefundGetCities implements GetRefundCities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundCitiesResponse>,
	) {}

	async get({signal, ...params}: GetRefundCitiesParams): Promise<GetRefundCitiesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
